'use client'

import React from 'react';

export function PreviewBadgeContent() {
  const handleDisablePreview = () => {
    fetch('/api/preview/disable').then(() => {
      window.location.reload();
    });
  };

  return (
    <button
      type="button"
      className="fixed z-40 top-4 left-4 px-4 py-2 rounded-full text-navigation-small uppercase font-heading bg-blue-500 text-fg-inverted font-semibold hover:bg-blue-300"
      onClick={handleDisablePreview}
    >
      DISABLE PREVIEW
    </button>
  );
}
